var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.354 9.646a.5.5 0 010 .708l-20 20a.5.5 0 01-.708-.708l20-20a.5.5 0 01.708 0z",
    fill: "var(--iconColorPrimary, #235CEE)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.636 14.528V18h-2.268v-3.5L7.574 8.2h2.408l2.618 4.354L15.218 8.2h2.226l-3.808 6.328zM31.997 23.2V33h-1.862l-4.886-5.95V33h-2.24v-9.8h1.876l4.872 5.95V23.2h2.24z",
    fill: "var(--iconColorPrimary, #235CEE)"
  })));
}
export default SvgYesNo;